"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions");

var _AdAccount = _interopRequireDefault(require("./AdAccount"));

var _ConnectedUser = _interopRequireDefault(require("./ConnectedUser"));

var _LeadSyncingEntity = _interopRequireDefault(require("./LeadSyncingEntity"));

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  adAccounts: (0, _immutable.List)(),
  connectedUsers: (0, _immutable.List)(),
  availableAdAccounts: (0, _immutable.Map)(),
  availableLeadSyncingEntities: (0, _immutable.Map)(),
  selectedLeadSyncingEntities: (0, _immutable.List)(),
  allowEmailLessFormSubmissions: null
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchAdAccountsActionTypes.SUCCESS, function (state, action) {
  return state.set('adAccounts', (0, _immutable.List)(action.payload.data.accounts.map(_AdAccount.default))).set('allowEmailLessFormSubmissions', !!action.payload.data.allowEmailLessFormSubmissions);
}), (0, _defineProperty2.default)(_handleActions, _actions.SetAdAccountTrackingActionTypes.REQUEST, function (state, action) {
  var _action$payload$data = action.payload.data,
      network = _action$payload$data.network,
      adAccountId = _action$payload$data.adAccountId,
      trackingEnabled = _action$payload$data.trackingEnabled; // state.adAccounts.accounts is a plain JS array, rather than an Immutable List.
  // This should be corrected eventually.

  var accounts = state.getIn(['adAccounts']);
  return state.setIn(['adAccounts'], accounts.map(function (account) {
    return account.network === network && account.accountId === adAccountId ? account.set('trackingEnabled', trackingEnabled) : account;
  }));
}), (0, _defineProperty2.default)(_handleActions, _actions.SetAdAccountTrackingActionTypes.FAILURE, function (state, action) {
  var _action$payload$props = action.payload.props,
      network = _action$payload$props.network,
      adAccountId = _action$payload$props.adAccountId,
      trackingEnabled = _action$payload$props.trackingEnabled; // Undo the above case.

  var accounts = state.getIn(['adAccounts']);
  return state.setIn(['adAccounts'], accounts.map(function (account) {
    return account.network === network && account.accountId === adAccountId ? account.set('trackingEnabled', !trackingEnabled) : account;
  }));
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchConnectedUsersActionTypes.REQUEST, function (state) {
  // Remove stale data
  return state.set('connectedUsers', (0, _immutable.List)());
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchConnectedUsersActionTypes.SUCCESS, function (state, action) {
  return state.set('connectedUsers', (0, _immutable.List)(action.payload.data.map(function (user) {
    return (0, _ConnectedUser.default)(user);
  })));
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchAvailableLeadSyncingEntitiesActionTypes.SUCCESS, function (state, action) {
  var network = action.payload.props.network;
  var entities = (0, _immutable.List)(action.payload.data.map(function (entity) {
    return (0, _LeadSyncingEntity.default)(entity);
  }));
  return state.setIn(['availableLeadSyncingEntities', network], entities);
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchSelectedLeadSyncingEntitiesActionTypes.SUCCESS, function (state, action) {
  var entities = (0, _immutable.List)(action.payload.data.map(function (entity) {
    return (0, _LeadSyncingEntity.default)(entity);
  }));
  return state.set('selectedLeadSyncingEntities', entities);
}), (0, _defineProperty2.default)(_handleActions, _actions.DeleteAdAccountActionTypes.REQUEST, function (state, action) {
  var _action$payload$data2 = action.payload.data,
      network = _action$payload$data2.network,
      adAccountId = _action$payload$data2.adAccountId;
  return state.updateIn(['adAccounts'], function (adAccounts) {
    return adAccounts.filter(function (account) {
      return account.network !== network || account.accountId !== adAccountId;
    });
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.DeleteUserAuthActionTypes.REQUEST, function (state, action) {
  // Optimistically delete user auth, since it's unlikely to fail
  var _action$payload$data3 = action.payload.data,
      network = _action$payload$data3.network,
      networkUserId = _action$payload$data3.networkUserId;
  return state.updateIn(['authedUsersForCurrentUser', network], function (users) {
    return users.filter(function (userId) {
      return userId !== networkUserId;
    });
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.ChangeEmailLessFormSubmissionSettingActionTypes.REQUEST, function (state) {
  return state.set('allowEmailLessFormSubmissions', !state.get('allowEmailLessFormSubmissions'));
}), (0, _defineProperty2.default)(_handleActions, _actions.ChangeEmailLessFormSubmissionSettingActionTypes.FAILURE, function (state) {
  return state.set('allowEmailLessFormSubmissions', !state.get('allowEmailLessFormSubmissions'));
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;